import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface ApplicationFiltersState {
  // Filter values
  search: string
  healthStatus: string[]
  syncStatus: string[]
  setupStatus: string[]
  sortBy: 'name' | 'created' | 'updated'
  sortOrder: 'asc' | 'desc'

  // Actions
  setSearch: (search: string) => void
  setHealthStatus: (status: string[]) => void
  setSyncStatus: (status: string[]) => void
  setSetupStatus: (status: string[]) => void
  setSortBy: (field: 'name' | 'created' | 'updated') => void
  toggleSortOrder: () => void
  resetFilters: () => void
}

const initialState = {
  search: '',
  healthStatus: [],
  syncStatus: [],
  setupStatus: [],
  sortBy: 'name' as const,
  sortOrder: 'asc' as const,
}

export const useApplicationFiltersStore = create<ApplicationFiltersState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setSearch: (search) => set({ search }),
        setHealthStatus: (healthStatus) => set({ healthStatus }),
        setSyncStatus: (syncStatus) => set({ syncStatus }),
        setSetupStatus: (setupStatus) => set({ setupStatus }),
        setSortBy: (sortBy) => set({ sortBy }),
        toggleSortOrder: () =>
          set((state) => ({
            sortOrder: state.sortOrder === 'asc' ? 'desc' : 'asc'
          })),
        resetFilters: () => set(initialState),
      }),
      { name: 'application-filters' }
    ),
    { name: 'ApplicationFiltersStore' }
  )
)
